import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { IContactes, IContactesResponse } from '../contactes.interfaces';
import { IClientsSocis } from '../../clientsSocis/clientssocis.interfaces';

import { ContactesService } from '../../services/contactes/contactes.service';
import { ClientsSocisService } from '../../services/clients_socis/clientsSocis.service';

@Component({
  selector: 'mcrit-gestio-manage-contactes',
  templateUrl: './manage-contactes.component.html',
  styleUrls: ['./manage-contactes.component.scss'],
  providers: [ContactesService, ClientsSocisService]
})
export class ManageContactesComponent implements OnInit, OnDestroy {
  private routeParamsSubs: any;
  private contacteModel: IContactes = {
      'id': 'NEW',
      'nom': '',
      'tipus': '',
      'tlf': '',
      'adreca': '',
      'email': '',
//      'skype': '',
      'linkedin': '',
      'mobil': '',
      'comentari': '',
      'empresa': '',
      'ambit': '',
      'id_client': null,
      'professional': false,
      'nota': null,
      'data_nota': null,
    'pais': null,
    'tematica1': null,
    'tematica2': null,
    'tematica3': null,
    'tematica4': null,
    'tematica5': null
  };
  private id: string;
  public error: string = '';
  public txFiltre: string = '';
  public showAsyncProgress: boolean = false;
  public editContacteData: IContactes;
  public llistaClients: Array<IClientsSocis>;
  public ambit: Array<string>;
  //public possibleTipus: Array<string> = ['Administratiu', 'Arquitecte', 'Coordinador', 'Director', 'Tècnic'];

  public tbEmpreses: any;

  public filterStates(val: string) {
    if(!this.tbEmpreses)this.tbEmpreses=this.llistaClients;
    
    if(val)return this.llistaClients.filter(item => item.nom.toLowerCase().startsWith(val.toLowerCase()));
    return this.llistaClients;
  }

  public deleteContacte(): void {
    if(confirm("Confirma l'esborrat del contacte")){
      this.showAsyncProgress = true;
      this.contactesService.delete(<number> this.editContacteData.id)
        .subscribe(deletedContacte => {
          this.showAsyncProgress = false;
          if(deletedContacte.err){this.error = deletedContacte.err;return;}
          console.log("S'ha esborrat el contacte");this.router.navigate(['contactes']);
        });
    }
  }

  constructor(private contactesService: ContactesService, private clientsSocisService: ClientsSocisService, protected route: ActivatedRoute, protected router: Router){ }

  ngOnInit() {
    this.routeParamsSubs = this.route.params.subscribe(params => {
      this.id = params['id'];
       this.clientsSocisService.getList(100000,0,{'client':true,'soci': true},{},{'nom': 'ASC'})
        .subscribe(
           clientsSocis=> { this.llistaClients = clientsSocis.rows; },
          error => console.log(error)
        );
      if(this.id === 'NEW'){this.editContacteData = this.contacteModel;return;}
      this.contactesService.getContacte(this.id)
        .subscribe(
           data=> {
            this.editContacteData = data.rows[0];
            this.ambit = (this.editContacteData && this.editContacteData.ambit?this.editContacteData.ambit.split(";"):null);
          },
          error => console.log(error)
        );
    });
  }

  ngOnDestroy() { this.routeParamsSubs.unsubscribe(); }
}
